export const SectionHeader = ({ children }) => (
  <div className="px-3 py-1.5 text-[10px] font-semibold uppercase tracking-wider text-gray-400 bg-gray-50 border-b border-gray-100">
    {children}
  </div>
);
